import { render } from "./iconBadge.vue?vue&type=template&id=6184c9a2"
import script from "./iconBadge.vue?vue&type=script&lang=js"
export * from "./iconBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__